var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { customAttribute, bindable, IPlatform } from '@aurelia/runtime-html';
const scrollbarStyle = `
.sb {
  scrollbar-width: thin;
  scrollbar-color: royalblue;
}
.sb.sb-x, .scrollbar-x {
  overflow-x: auto;
  overflow-y: hidden;
}
.sb.sb-y, .scrollbar-y {
  overflow-x: hidden;
  overflow-y: auto;
}
.sb::-webkit-scrollbar {
  width: 6px;
  background-color: rgba(224, 224, 224, 0.5);
}
.sb::-webkit-scrollbar:vertical {
  width: 6px;
  scrollbar-width: 6px;
}
.sb::-webkit-scrollbar:horizontal {
  height: 6px;
  scrollbar-width: 6px;
}

.sb::-webkit-scrollbar-thumb {
  background-color: royalblue;
}`;
let Scrollbar = class Scrollbar {
    constructor(element, p) {
        this.element = element;
        const doc = p.document;
        if (!('hasSb' in doc)) {
            const style = doc.createElement('style');
            style.textContent = scrollbarStyle;
            document.head.appendChild(style);
            doc['hasSb'] = true;
        }
        element.classList.add('sb');
    }
    binding() {
        const element = this.element;
        const direction = this.value;
        const classList = element.classList;
        if (direction === 'horizontal' || direction === 'x') {
            classList.add('sb-x');
            classList.add('text-nowrap');
            element.addEventListener('wheel', this, true);
        }
        else {
            classList.add('sb-y');
        }
    }
    unbinding() {
        this.element.removeEventListener('wheel', this, true);
    }
    handleEvent(e) {
        this.handleWheel(e);
    }
    handleWheel(e) {
        if (!e.shiftKey && e.deltaY !== 0) {
            e.currentTarget.scrollLeft += e.deltaY;
            e.stopImmediatePropagation();
            e.preventDefault();
        }
    }
};
Scrollbar.inject = [Element, IPlatform];
__decorate([
    bindable,
    __metadata("design:type", String)
], Scrollbar.prototype, "value", void 0);
Scrollbar = __decorate([
    customAttribute('scrollbar'),
    __metadata("design:paramtypes", [Element, Object])
], Scrollbar);
export { Scrollbar };
